export default __webpack_public_path__ + "static/media/edgy, surreal, professional.ac710ea8.jpeg";